import { RuleId } from '@wix/a11y-rules';
export const EDITOR_TYPES = {
  EDITOR: 'EDITOR',
  STUDIO: 'STUDIO'
};
export const VERSION_FINGERPRINT = JSON.stringify({
  RuleId
});
//# sourceMappingURL=constants.js.map